




















































































import Vue from "vue";
import { $eventsBus } from "@/main";
import PartsController from "@/app/modules/work/components/right-panel/TheRightPanelPartsController.vue";
import TransitionsController from "@/app/modules/work/components/right-panel/TheRightPanelTransitionsController.vue";
import AudioController from "@/app/modules/work/components/right-panel/TheRightPanelAudioController.vue";
import RendersController from "@/app/modules/work/components/right-panel/TheRightPanelRendersController.vue";

import vueCustomScrollbar from "vue-custom-scrollbar";

export default Vue.extend({
  name: "RightPanel",
  components: {
    PartsController,
    TransitionsController,
    AudioController,
    RendersController,
    vueCustomScrollbar,
  },
  data: function () {
    return {
      openedItemsNames: ["Parts"],
    };
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
  },
  watch: {},
  created() {
    $eventsBus.$on("openTabInRightPanel", (name) => {
      if (!this.openedItemsNames.includes(name)) {
        this.onClickArrow(name);
      }
    });
  },
  methods: {
    onClickArrow(name) {
      if (!this.openedItemsNames.includes(name)) {
        this.closeAllMinorTabs();
        this.openedItemsNames.push(name);
        if (name === "Duration") {
          $eventsBus.$emit("showVideoRangeSlider", true);
        }
        if (name === "EndCard") {
          $eventsBus.$emit("showVideoPackshotTimeline", true);
        }
      } else {
        this.openedItemsNames.splice(this.openedItemsNames.indexOf(name), 1);
        if (name === "Duration") {
          $eventsBus.$emit("showVideoRangeSlider", false);
        }
        if (name === "EndCard") {
          $eventsBus.$emit("showVideoPackshotTimeline", false);
        }
      }
    },
    closeAllMinorTabs() {
      this.openedItemsNames = this.openedItemsNames.filter((name) => {
        if (name === "Duration") {
          $eventsBus.$emit("showVideoRangeSlider", false);
        }
        if (name === "EndCard") {
          $eventsBus.$emit("showVideoPackshotTimeline", false);
        }
        return name === "Output size";
      });
    },
  },
});
